/* eslint-disable react/style-prop-object */
import React from 'react';

export const AccessDenied: React.FC = () => {
	return (
		<svg width="170" height="90" viewBox="0 0 170 90" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect y="32" width="170" height="58" rx="8" fill="url(#paint0_linear_4731_238831)" />
			<rect opacity="0.35" x="9" y="74" width="128" height="6" rx="3" fill="#D8D9E1" />
			<rect opacity="0.35" x="9" y="58" width="118" height="6" rx="3" fill="#D8D9E1" />
			<rect opacity="0.35" x="9" y="42" width="145" height="6" rx="3" fill="#D8D9E1" />
			<circle cx="85" cy="25" r="25" fill="#D8D9E1" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M88.9909 16.5814C87.1744 13.5842 82.8256 13.5842 81.0091 16.5814C80.567 17.3108 80.3333 18.1473 80.3333 19.0002V22.2826H79.6667C78.1939 22.2826 77 23.4765 77 24.9493V32.9493C77 34.4221 78.1939 35.616 79.6667 35.616H90.3333C91.8061 35.616 93 34.4221 93 32.9493V24.9493C93 23.4765 91.8061 22.2826 90.3333 22.2826H89.6667V19.0002C89.6667 18.1473 89.433 17.3108 88.9909 16.5814ZM88.3333 22.2826V19.0002C88.3333 18.391 88.1664 17.7935 87.8507 17.2725C86.5532 15.1316 83.4468 15.1316 82.1493 17.2725C81.8336 17.7935 81.6667 18.391 81.6667 19.0002V22.2826H88.3333ZM84.3333 29.616V28.7709C83.9348 28.5404 83.6667 28.1095 83.6667 27.616C83.6667 26.8796 84.2636 26.2826 85 26.2826C85.7364 26.2826 86.3333 26.8796 86.3333 27.616C86.3333 28.1095 86.0652 28.5404 85.6667 28.7709V29.616C85.6667 29.9842 85.3682 30.2826 85 30.2826C84.6318 30.2826 84.3333 29.9842 84.3333 29.616Z"
				fill="#2E3641"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_4731_238831"
					x1="85"
					y1="32"
					x2="85"
					y2="90"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="white" />
					<stop offset="1" stop-color="white" stop-opacity="0" />
				</linearGradient>
			</defs>
		</svg>
	);
};
